import { NavItem } from "../types";

export const NAV_ITEMS: NavItem[] = [
	{
		label: "Sobre mí",
		path: "/#sobre-mi",
		visible: true,
		active: true,
	},
	{
		label: "Proyectos",
		path: "/#proyectos",
		children: [
			{
				label: "Todo lo que no ves",
				path: "/todo-lo-que-no-ves",
				visible: true,
				active: true,
			},
			{
				label: "Asociación Equilibrio",
				path: "/asociacion-equilibrio",
				children: [
					{
						label: "Lidera",
						path: "/asociacion-equilibrio/lidera",
						visible: true,
						active: true,
					},
					{
						label: "Contacto",
						path: "/asociacion-equilibrio#contacto",
						visible: true,
						active: true,
					},
				],
				visible: true,
				active: true,
			},
		],
		visible: true,
		active: true,
	},
	{
		label: "Conferencias",
		path: "/#conferencias",
		visible: true,
		active: true,
	},
];

export const EXTRA_NAV_ITEMS: NavItem[] = [];
